import { useCreateProjectInfoStore } from 'store/local/projectCreateinfo';

export const useCreateProjectPartner = () => {
  // SECTION: declare local state
  const { selectedSyncPartner, setSelectedSyncPartner, partnerName } = useCreateProjectInfoStore();

  // SECTION: declare variable

  // SECTION: declare state

  // SECTION: declare function
  const handleOptionClick = () => {};
  const handlePartnerSearch = () => {};
  const handlePartnerFetch = () => {};

  return {
    selectedSyncPartner,
    setSelectedSyncPartner,
    partnerName,
    onOptionClick: handleOptionClick,
    onPartnerSearch: handlePartnerSearch,
    onPartnerFetch: handlePartnerFetch,
  };
};
